export default "__VITE_ASSET__NCcy2kUz__"